import { useEffect, useState } from 'react';
import { sortBy } from 'lodash';
import { DataGridPro, GridToolbar } from '@mui/x-data-grid-pro';

import { Snackbar } from '@mui/material';

import { Client } from '@commons/types/clients';

import { Container, DataGridContainer } from '@commons/utils/genericStyledComponents';

import { ModuleProps } from '@src/commons/types/module';
import { NavigationBreadcrumb } from '@src/commons/NavigationBreadcrumb';

import clientsService from '@src/services/clientsService';
import userService from '@src/services/userService';

import { getTheme } from '@commons/utils/theme';

import { getColumns } from './utils/getColumns';

const Clients = (props: ModuleProps) => {
  const { getText } = props;

  const theme = getTheme();

  const [clients, setClients] = useState<Client[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [isClientConnectionLoading, setIsClientConnectionLoading] = useState<boolean>(false);
  const [snackBarProps, setSnackBarProps] = useState({
    open: false,
    message: ''
  });

  useEffect(() => {
    getClients();
  }, []);

  const handleClientConnection = async (row: Client) => {
    setIsClientConnectionLoading(true);
    try {
      const { accessToken } = await userService.inpulseClientLogin(row.id);

      window.open(`${import.meta.env.VITE_APP_URL}/client-login?accessToken=${accessToken}`);
    } catch {
      setSnackBarProps({
        open: true,
        message: 'Erreur lors de la connexion au client'
      });
    } finally {
      setIsClientConnectionLoading(false);
    }
  };

  const dataGridColumns = getColumns({ handleClientConnection, isClientConnectionLoading });

  const getClients = async () => {
    setIsLoading(true);
    try {
      const clients = await clientsService.findAssociatedClients();

      const sortedClients = sortBy(clients, 'name');

      setClients(sortedClients);
    } catch {
      setSnackBarProps({
        open: true,
        message: 'Erreur lors de la récupération des clients'
      });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      <NavigationBreadcrumb path={getText?.() || ''} />
      <Container>
        <DataGridContainer>
          <DataGridPro
            loading={isLoading}
            slots={{
              toolbar: GridToolbar
            }}
            slotProps={{
              toolbar: {
                showQuickFilter: true,
                printOptions: { disableToolbarButton: true },
                csvOptions: { disableToolbarButton: true }
              }
            }}
            rows={clients}
            columns={dataGridColumns}
            hideFooter
            sx={{
              // disable cell selection style
              '.MuiDataGrid-cell:focus': {
                outline: 'none'
              }
            }}
          ></DataGridPro>
        </DataGridContainer>
        <Snackbar
          open={snackBarProps.open}
          autoHideDuration={5000}
          onClose={() => setSnackBarProps({ open: false, message: '' })}
          message={snackBarProps.message}
          sx={{
            '& .MuiSnackbarContent-root': {
              backgroundColor: theme.colors.blacks.ipBlack8,
              borderRadius: '16px',
              border: `1px solid ${theme.colors.red.error}`,
              color: theme.colors.red.error
            }
          }}
        />
      </Container>
    </>
  );
};

export default Clients;
